<template>
    <div class="noticies-tab">
        <div class="noticies-tab__tabs">
            <ul>
                <li data-id="1" class="active"><p><strong>TV Mar 525 Net/Claro</strong></p></li>
            </ul>
        </div>
        <div class="noticies-tab__item">
            <div class="noticies-tab__options">
                <a data-id="1" href="http://tvmar.tv.br/novo/" target="_self" class="noticies-item noticies-live active" >
                    <div class="noticies-item--image">
                        <div id="playerElement" />
                        <span class="live-badge">Ao vivo</span>
                        <div class="live-controls"></div>
                    </div>
                </a>
            </div>
            <slot></slot>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'Tabs',
    data() {
        return {
            player: null
        }
    },
    methods:{
        destroy() {
            this.player.destroy();
        }
    },
    mounted() {
        this.player = window.WowzaPlayer.create('playerElement',{
            "license":"PLAY1-nPJNh-DmHwn-Kafk6-9DG9T-ETEjr",
            "title":"",
            "description":"TV MAR",
            "sourceURL":"https://virtues.es:1936/tvmar/tvmar/playlist.m3u8",
            "autoPlay":true,
            "volume":"75",
            "mute":true,
            "loop":false,
            "audioOnly":false,
            "uiShowQuickRewind":false,
            "posterFrameURL":"https%3A%2F%2Fwww.tvmar.tv.br%2Fimg%2FTvMarGazetaWeb.gif",
            "endPosterFrameURL":"https%3A%2F%2Fwww.tvmar.tv.br%2Fimg%2FTvMarGazetaWeb.gif",
            "uiPosterFrameFillMode":"fill",
            debugLevel:'ERROR',
        })

        this.$root.$on('gazetaweb:closelive', () => {
            this.destroy()
        })
    },
    beforeDestroy() {
        // this.destroy()
    },
}
</script>